module.exports = __webpack_public_path__ + "static/img/smartstation21.8b7f6e81.png";